<div class="ui middle aligned center aligned grid"
	style="height: 100%;">
	<div class="center aligned column"
		[ngStyle]="{'width': account.requiresTwoFactorActivation && !account.requiresTwoFactorActivationDays && !account.requiresTwoFactor ? '900px' : '400px'}">

		@if (loading) {
		<div
			class="ui basic segment"
			style="width: 100%; height: 250px;">
			<div class="ui active inverted dimmer">
				<div class="ui medium text blue slow double loader"
					style="font-style: italic;">
					Loading
				</div>
			</div>
		</div>
		}
		@else {
		<div class="ui segment"
			style="margin-bottom: 100px;">
			<a [attr.data-tooltip]="appVersion"
				data-variation="small blue"
				style="display: inline-block; margin-top: 20px; margin-bottom: 20px;"
				href="">
				<img src="assets/images/logo.png"
					class="image" />
			</a>

			<form class="ui large form" (submit)="onSubmit()">
				<div class="ui segment">
					@if (account.requiresPasswordReset) {
					<ng-template [ngTemplateOutlet]="resetPasswordTemplate" />
					}
					@else if (account.requiresTwoFactor) {
					<ng-template [ngTemplateOutlet]="twoFactorTemplate" />
					}
					@else if (account.requiresTwoFactorActivation) {
					<ng-template [ngTemplateOutlet]="twoFactorEnableTemplate" [ngTemplateOutletContext]="{ twoFactorDays: account.requiresTwoFactorActivationDays }" />
					}
					@else {
					<ng-template [ngTemplateOutlet]="loginTemplate" />
					}
				</div>

				<div class="field" app-field *ngIf="errors.length" [errors]="errors"></div>
			</form>
		</div>
		}
	</div>
</div>

<ng-template #loginTemplate>

	<div class="field" app-field [error]="loginValidation | path: 'userName'">
		<div class="ui left icon input">
			<i class="user icon"></i>
			<input type="text"
				autoComplete="off"
				name="userName"
				[placeholder]="userNamePlaceHolder"
				[maxlength]="userNameMaxLength"
				[(ngModel)]="loginModel.userName">
		</div>
	</div>

	<div class="field" app-field [error]="loginValidation | path: 'password'">
		<div class="ui left icon input">
			<i class="lock icon"></i>
			<input type="password"
				style="-text-security:disc; -webkit-text-security:disc;"
				autoComplete="off"
				name="password"
				[placeholder]="passwordPlaceHolder"
				[maxlength]="passwordMaxLength"
				[(ngModel)]="loginModel.password">
		</div>
	</div>

	<button class="ui fluid large blue button"
		[class.disabled]="loginInvalid"
		type="submit">
		Login
	</button>

</ng-template>

<ng-template #twoFactorEnableTemplate let-twoFactorDays="twoFactorDays">
	@if (twoFactorDays) {

	Due to security concerns, you should consider <br />enabling a two-factor authenticator.
	<br /><br />

	<button class="ui primary tertiary button"
		style="padding: 0 !important;"
		(click)="account.requiresTwoFactorActivationDays = 0">
		Click here
	</button> if you want to enable it now.

	<br /><br />
	You can also skip this for now, but keep in mind that <br />
	<strong>after <span class="ui medium red text"> {{account.requiresTwoFactorActivationDays}} days</span>, it will be mandatory</strong>.

	<br /><br />

	<a class="ui fluid large green button"
		[class.disabled]="loginInvalid"
		(click)="logIn()">
		Continue
	</a>

	} @else {

	Due to security concerns, you need to enable a two-factor authenticator.
	<br />
	<strong><span class="ui blue text">Note</span>: Your choice is not final, it can be updated later from the user menu (top right).</strong>

	<div class="ui divider"></div>
	<br />

	<div class="ui two column grid">
		<div class="row">
			<div class="ui vertical divider">
				Or
			</div>

			<div class="column">
				<h4 class="ui center aligned header">
					<div class="content">
						<i class="alternate big mobile icon"></i>
						Mobile Authenticator
						<div class="sub header">
							<div class="ui small toggle checkbox">
								<input type="checkbox"
									[(ngModel)]="authenticator.mobileEnabled"
									(change)="authenticator.emailEnabled= false" />
								<label>
									<strong class="ui success text">
										@if (authenticator.mobileEnabled) {
										<span class="ui success text">Enabled</span>
										}
										@else {
										<span class="ui error text">Disabled</span>
										}
									</strong>
								</label>
							</div>
						</div>
					</div>
				</h4>
			</div>

			<div class="column">
				<h4 class="ui center aligned header">
					<div class="content">
						<i class="big envelope outline icon"></i>
						Email Authenticator
						<div class="sub header">
							<div class="ui small toggle checkbox">
								<input type="checkbox" [(ngModel)]="authenticator.emailEnabled" (change)="authenticator.mobileEnabled = false" />

								<label>
									<strong class="ui success text">
										@if (authenticator.emailEnabled) {
										<span class="ui success text">Enabled</span>
										}
										@else {
										<span class="ui error text">Disabled</span>
										}
									</strong>
								</label>
							</div>
						</div>
					</div>
				</h4>
			</div>
		</div>
	</div>

	@if (authenticator.mobileEnabled && authenticator.mobile) {
	<div style="text-align: left; margin-top: 20px;">
		<div class="ui attached segment">
			<p>We recommend installing "Google Authenticator" app and following these steps:</p>
		</div>

		<div class="ui attached segment">
			<div class="ui two column stackable grid">
				<div class="row">
					<div class="ui vertical divider">Or</div>

					<div class="column">
						<ol>
							<li>Open "Google Authenticator" app.</li>
							<li>Authenticate in the app if desired or necessary.</li>
							<li>Click the "+" button in the right corner.</li>
							<li>Select "Scan a QR code".</li>
							<li>Point the camera at the QR image below.</li>
						</ol>

						<div style="text-align: center;">
							<qr-code [value]="authenticator.mobile.authenticatorUri"
								size="300"
								errorCorrectionLevel="M" />
						</div>
					</div>

					<div class="column">
						<ol>
							<li>Open "Google Authenticator" app.</li>
							<li>Authenticate in the app if desired or necessary.</li>
							<li>Click the "+" button in the right corner.</li>
							<li>Select "Enter a setup key".</li>
							<li>Enter "Account name", e.g. "NSTEP".</li>
							<li>Select the field "Key" and input the values below.</li>
							<li>Finish by pressing "Add".</li>
						</ol>

						<br />

						<div style="text-align: center;">
							<div class="ui big labels">
								@for (part of authenticator.mobile.sharedKey; track $index) {
								<div class="ui label">
									<strong>{{part}}</strong>
								</div>
								}
							</div>
						</div>
					</div>

				</div>
			</div>
		</div>

		<div class="ui attached segment">
			After you click the button below, we will request a code to confirm the authenticator.
		</div>

	</div>
	}

	@if (authenticator.emailEnabled) {
	<div class="ui attached segment"
		style="margin-top: 20px">
		<div class="ui two column centered grid">
			<div class="column">
				<div class="field">
					<label>Email Address</label>
					<input type="text" [(ngModel)]="email">
				</div>
			</div>
		</div>
	</div>

	<div class="ui attached segment">
		After you click the button below, we will send an email with the code and request it to confirm the authenticator.
	</div>
	}

	@if (authenticator.mobileEnabled || authenticator.emailEnabled) {
	<a class="ui large blue button"
		(click)="confirmAuthenticator()"
		style="margin-top: 20px">
		Continue
	</a>
	}

	<br />

	}
</ng-template>

<ng-template #resetPasswordTemplate>

	<p style="text-align: left;">
		Due to security concerns you need to change your current password
	</p>

	<div class="field">
		<div class="field" app-field [error]="resetValidation | path: 'newPassword'">
			<div class="ui left icon input">
				<i class="lock icon"></i>
				<input type="password"
					style="-text-security:disc; -webkit-text-security:disc;"
					autoComplete="off"
					name="newPassword"
					[placeholder]="'New Password'"
					[(ngModel)]="resetModel.newPassword">
			</div>
		</div>
	</div>

	<div class="field">
		<div class="field" app-field [error]="resetValidation | path: 'confirmPassword'">
			<div class="ui left icon input">
				<i class="lock icon"></i>
				<input type="password"
					style="-text-security:disc; -webkit-text-security:disc;"
					autoComplete="off"
					name="confirmPassword"
					[placeholder]="'Confirm Password'"
					[(ngModel)]="resetModel.confirmPassword">
			</div>
		</div>
	</div>

	<button class="ui fluid large blue button"
		[class.disabled]="resetInvalid"
		type="submit">
		Change Password
	</button>

</ng-template>

<ng-template #twoFactorTemplate>
	@if (twoFactorOptions.length) {
	<div class="grouped fluid fields">
		@if (twoFactorOptions.length > 1) {
		<label style="font-size: 1.1em;">
			How do you want to provide the <br /><span class="ui blue text" style="font-weight: bold;">Two-factor Code</span>?
		</label>
		}

		@for (opt of twoFactorOptions; track $index) {
		<div class="field">
			<a class="ui big black basic button"
				(click)="selectTwoFactor(opt.key)"
				[class.disabled]="!opt.enabled"
				style="width: 100%;">
				<i class="{{opt.icon}}"></i> {{opt.value}}
				<sub><br />{{opt.desc}}</sub>
			</a>
		</div>
		}
	</div>
	}

	@if (!twoFactorOptions.length || twoFactorSelected) {

	<div class="field">
		<label style="margin-bottom: 15px;">
			<i class="shield alternate icon"></i>
			Enter the code from your authenticator:<br />
		</label>

		<div class="ui six wide fields"
			style="margin-bottom: 15px;">
			@for (num of [].constructor(6); track $index; let i = $index) {
			<div class="field">
				<input id="digit-{{i}}"
					type="text"
					maxlength="1"
					pattern="[0-9]"
					inputmode="numeric"
					style="font-weight: bold; text-align: center; font-size: larger; padding-left: 0; padding-right: 0;"
					(input)="handleInput($event, i)"
					(keydown)="handleKeyDown($event, i)"
					(paste)="handlePaste($event)"
					[(ngModel)]="code[i]" />
			</div>
			}
		</div>

		<div class="ui small blue header"
			style="margin-bottom: .75rem;">
			Trust this device?
		</div>

		<div style="display: flex; align-items: flex-start; gap: 1rem;">
			<div class="ui fitted checkbox" style="margin-top: .15rem;">
				<input
					type="checkbox"
					id="rememberDevice"
					name="rememberDevice"
					[(ngModel)]="loginModel.trustDevice" />
				<label for="rememberDevice"></label>
			</div>

			<label
				for="rememberDevice"
				style="line-height: 1.35; cursor: pointer; margin: 0; text-align: left;">
				Remember this device for <strong>{{ account.trustDeviceForDays }} days</strong>
				and skip <br />two-factor authentication during that period.
			</label>
		</div>
	</div>

	<button class="ui fluid large blue button"
		type="submit">
		@if (account.requiresPasswordReset) {
		Change Password
		}
		@else if (account.requiresTwoFactorActivation) {
		Enable Authenticator
		}
		@else {
		Login
		}
	</button>
	}
</ng-template>